<div class="popup-search-block" *ngIf="isSearchOn">
    <kendo-textbox class="searchField-Text" [(ngModel)]="searchString"
        placeholder="{{placeHolderValue}}" (keydown.enter)="popupEquipmentSearch()"></kendo-textbox>
    <div class="searchField-Action">
      <button class="search-action" (click)="popupEquipmentSearch()">
        {{buttonText}}
      </button>
        <button class="reset-action" (click)="resetData()">Reset</button>
    </div>
</div>

<div class="popup-table-block">
    <div id="nonStyleGrid">
    <kendo-grid  [data]="dataList" [pageable]="true" [pageSize]="pageSize" [sortable]="true"
        [skip]="skip" (pageChange)="pageChange($event)">
        <kendo-grid-column *ngFor="let column of columnConfig" [field]="column.field" [title]="column.title"
            [width]="column.width"> 
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem[column.field] }} <span *ngIf="dataItem?.isNewStatus && column?.showSpecialStatus" class="new-status">&nbsp;&nbsp;(NEW)</span>
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [width]="100">
            <ng-template kendoGridCellTemplate let-dataItem>
                <div class="btn-col">
                    <button (click)="buttonClicked(dataItem)">{{buttonName}}</button>
                </div>
            </ng-template>
        </kendo-grid-column>

        <ng-template kendoPagerTemplate class="KendoPager">
            <div class="pagerHome">
            <div class="pagerLeft">
                <kendo-pager-info></kendo-pager-info>
            </div>
            <div class="pagerRight">
                <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                <kendo-pager-numeric-buttons [buttonCount]="3"></kendo-pager-numeric-buttons>
                <kendo-pager-next-buttons></kendo-pager-next-buttons>
            </div>
        </div>
        </ng-template>
    </kendo-grid>
    </div>
</div>
